import { useBooleanState } from '@cian/react-utils';

import { useCallback, useEffect } from 'react';

import { MapHintService } from '@/microfrontends/map/shared/services/MapHintService';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

const mapHintService = new MapHintService();

type UseToggleMapButtonHint = {
  handleMapHintClose: VoidFunction;
  isMapHintOpen: boolean;
};

export function useToggleMapButtonHint(): UseToggleMapButtonHint {
  const { state: isMapHintOpen, setTrue: setMapHintOpen, setFalse: setMapHintClosed } = useBooleanState(false);
  const isNarrowListing = useListingLayoutIsNarrowSelector();

  useEffect(() => {
    if (mapHintService.getMapHintEnabledForUser() && !isNarrowListing) {
      /**
       * Небольшой хак, чтобы тултип корректно спозиционировался, к тому же такое появление тултипа
       * выглядит симпатичнее
       */
      setTimeout(setMapHintOpen, 1000);
    }
  }, [setMapHintOpen, isNarrowListing]);

  const handleMapHintClose = useCallback(() => {
    setMapHintClosed();
    mapHintService.setMapHintDisabledForUser();
  }, [setMapHintClosed]);

  return {
    handleMapHintClose,
    isMapHintOpen,
  };
}
